import React from "react";

const InputField = ({ type, value, setValue, key, id, options }) => {
  const updateQaField = (id, data) => {
    const updatedQa = value?.qa?.map((item) => (item?.id === id ? { ...item, answer: data } : item));

    setValue((prevState) => ({
      ...prevState,
      qa: updatedQa,
    }));
  };

  return type === "input" ? (
    <input
      name={key}
      id={key}
      type="text"
      class="form-control"
      onChange={(e) => updateQaField(id, e.target.value)}
      value={value?.qa?.[id]?.answer}
    />
  ) : type === "textarea" ? (
    <textarea
      name={key}
      id={key}
      type="text"
      class="form-control"
      style={{ minHeight: "200px" }}
      onChange={(e) => updateQaField(id, e.target.value)}
      value={value?.qa?.[id]?.answer}
    />
  ) : type === "radio" ? (
    <div className="d-flex">
      {options?.map((ue, i) => (
        <div class="form-check radio ps-4 me-3">
          <input
            class="form-check-input"
            type="radio"
            name={`${value?.key}-${id}`}
            id={`${ue}-${value?.key}`}
            value={ue}
            checked={value?.qa?.[id]?.answer === ue}
            onChange={(e) => updateQaField(id, ue)}
          />
          <label class="form-check-label" for={`${ue}-${value?.key}`}>
            {ue}
          </label>
        </div>
      ))}
    </div>
  ) : (
    ""
  );
};

export default InputField;
